import { ProjectEvent, projectEvents } from "@Context/web-portal/byb360/project-events";
import { useEffect } from "react";

export const useTimelineEvents = (onEvent: (event: ProjectEvent) => void) => {
  useEffect(() => {
    const unsubscribe = projectEvents.onTimelineEvent(onEvent);
    return unsubscribe;
  }, [onEvent]);
};

export const useTimelineSeek = (onSeek: (newTime: number) => void) => {
  useEffect(() => {
    const unsubscribe = projectEvents.onTimelineEvent((event) => {
      if (event.type === "timeline_seek" || event.type === "timeline_time_change") {
        onSeek(event.matchTime!);
      }
    });
    return unsubscribe;
  }, [onSeek]);
};

export const useProjectEvents = (onEvent: (event: ProjectEvent) => void) => {
  useEffect(() => {
    const unsubscribe = projectEvents.onProjectEvent(onEvent);
    return unsubscribe;
  }, [onEvent]);
};

export { projectEvents };
